export const holidaysList = [
  // Standard Holidays
  { date: new Date('1/1/2026'), info: 'New Year', type: 'standard' },
  { date: new Date('1/26/2026'), info: 'Republic Day', type: 'standard' },
  { date: new Date('3/4/2026'), info: 'Holi', type: 'standard' },
  { date: new Date('8/15/2026'), info: 'Independence Day', type: 'standard' },
  { date: new Date('8/28/2026'), info: 'Raksha Bandhan', type: 'standard' },
  { date: new Date('10/2/2026'), info: 'Lal Bahadur Shastri', type: 'standard' },
  { date: new Date('10/20/2026'), info: 'Dussehra', type: 'standard' },
  { date: new Date('11/8/2026'), info: 'Deepavali', type: 'standard' },
  { date: new Date('11/11/2026'), info: 'Bhai Dooj', type: 'standard' },
  { date: new Date('12/31/2026'), info: 'New Year Eve', type: 'standard' },
  // Optional Holidays
  { date: new Date('1/14/2026'), info: 'Pongal', type: 'optional' },
  { date: new Date('1/14/2026'), info: 'Makar Sankranti', type: 'optional' },
  { date: new Date('1/23/2026'), info: 'Vasant Panchami', type: 'optional' },
  { date: new Date('2/1/2026'), info: 'Guru Ravidas Jayanti', type: 'optional' },
  { date: new Date('2/12/2026'), info: 'Maharishi Dayanand Saraswati Jayanti', type: 'optional' },
  { date: new Date('2/15/2026'), info: 'Maha Shivaratri / Shivaratri', type: 'optional' },
  { date: new Date('2/19/2026'), info: 'Shivaji Jayanti', type: 'optional' },
  { date: new Date('3/3/2026'), info: 'Holika Dahana', type: 'optional' },
  { date: new Date('3/19/2026'), info: 'Ugadi', type: 'optional' },
  { date: new Date('3/19/2026'), info: 'Gudi Padwa', type: 'optional' },
  { date: new Date('3/20/2026'), info: 'Jamat Ul-Vida', type: 'optional' },
  { date: new Date('3/21/2026'), info: 'Ramzan Id (Tentative Date)', type: 'optional' },
  { date: new Date('3/26/2026'), info: 'Rama Navami', type: 'optional' },
  { date: new Date('3/31/2026'), info: 'Mahavir Jayanti', type: 'optional' },
  { date: new Date('4/3/2026'), info: 'Good Friday', type: 'optional' },
  { date: new Date('4/5/2026'), info: 'Easter Day', type: 'optional' },
  { date: new Date('4/14/2026'), info: 'Vaisakhi', type: 'optional' },
  { date: new Date('4/14/2026'), info: 'Ambedkar Jayanti', type: 'optional' },
  { date: new Date('4/15/2026'), info: 'Bahag Bihu / Vaisakhadi', type: 'optional' },
  { date: new Date('5/1/2026'), info: 'Buddha Purnima / Vesak', type: 'optional' },
  { date: new Date('8/26/2026'), info: 'Onam', type: 'optional' },
  { date: new Date('9/4/2026'), info: 'Janmashtami', type: 'optional' },
  { date: new Date('9/14/2026'), info: 'Ganesh Chaturthi / Vinayaka Chaturthi', type: 'optional' },
  { date: new Date('10/11/2026'), info: 'First Day of Sharad Navratri', type: 'optional' },
  { date: new Date('10/18/2026'), info: 'Maha Saptami', type: 'optional' },
  { date: new Date('10/19/2026'), info: 'Maha Ashtami', type: 'optional' },
  { date: new Date('10/26/2026'), info: 'Maharishi Valmiki Jayanti', type: 'optional' },
  { date: new Date('10/29/2026'), info: 'Karaka Chaturthi (Karva Chauth)', type: 'optional' },
  { date: new Date('10/31/2026'), info: 'Halloween', type: 'optional' },
  { date: new Date('11/9/2026'), info: 'Govardhan Puja', type: 'optional' },
  { date: new Date('11/15/2026'), info: 'Chhat Puja (Pratihar Sashthi / Surya Sashthi)', type: 'optional' },
  { date: new Date('11/24/2026'), info: 'Guru Nanak Jayanti', type: 'optional' },
  { date: new Date('12/23/2026'), info: 'Hazarat Ali\'s Birthday', type: 'optional' },
  { date: new Date('12/24/2026'), info: 'Maharishi Dayanand Saraswati Jayanti', type: 'optional' },
  { date: new Date('12/25/2026'), info: 'Christmas', type: 'optional' },
];




export const getHolidaysThisMonth = () => {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();
  const holidaysThisMonth = holidaysList.filter((holiday) => {
    const holidayDate = new Date(holiday.date);
    return (
      holidayDate.getFullYear() === currentYear &&
      holidayDate.getMonth() === currentMonth
    );
  });
  const upcomingHolidays = holidaysThisMonth.filter((holiday) => {
    const holidayDate = new Date(holiday.date);
    holidayDate.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);
    return holidayDate.getTime() > now.getTime();
  });
  upcomingHolidays.sort((a, b) => a.date.getTime() - b.date.getTime());

  return {
    holidays: upcomingHolidays.slice(0, 2),
    totalHolidays: holidaysThisMonth.length,
  };
};
